import { AdCheckoutCurrency } from "@/sell/models/checkout/state/AdCheckoutCurrency";

export const CurrencyService = {
  EncodeDollars(auDollars: number): AdCheckoutCurrency {
    return CurrencyService.EncodeCents(Math.round(auDollars * 100));
  },
  EncodeCents(auCents: number): AdCheckoutCurrency {
    if (auCents === -0) {
      auCents = 0;
    }
    const sign = auCents < 0 ? "-" : "";
    return {
      amountAUCents: auCents,
      display: `${sign}$${(Math.abs(auCents) / 100).toFixed(2)}`.replace(".00", ""),
    };
  },
  DollarsToCents(auDollars: number): number {
    return Math.round(auDollars * 100);
  },
  CentsToDollars(auCents: number): number {
    return auCents / 100;
  },
};
